import React, { useState } from 'react';
import { Stack } from '@hub/stack';
import { Input, InputGroup, InputRightElement } from '@hub/input';
import { FormLabel, FormControl, FormErrorMessage } from '@hub/form';
import { colors } from '@hub/design-system-base';
import { IconButton } from '@hub/button';
import { EyeClosedMediumIcon, EyeOpenMediumIcon } from '@hub/icon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FormInput = _ref => {
  let {
    id,
    name,
    label,
    value,
    placeholder,
    type = 'text',
    inputMode,
    autoComplete,
    autoCorrect,
    autoCapitalize,
    pattern,
    maxLength,
    isInvalid,
    errorMessage,
    isLoading = false,
    onChange,
    onBlur
  } = _ref;
  const {
    0: inputType,
    1: setInputType
  } = useState(type);
  return /*#__PURE__*/_jsx(FormControl, {
    id: id,
    isInvalid: isInvalid,
    "data-id": "form_form-input_FormInput_FormControl",
    children: /*#__PURE__*/_jsxs(Stack, {
      gap: "spacing-sm",
      "data-id": "form_form-input_FormInput_FormControl_Stack",
      children: [label && /*#__PURE__*/_jsx(FormLabel, {
        htmlFor: id,
        sx: {
          color: isInvalid ? colors.error : ''
        },
        "data-id": "form_form-input_FormInput_FormLabel",
        children: label
      }), /*#__PURE__*/_jsxs(InputGroup, {
        "data-id": "form_form-input_FormInput_Stack_InputGroup",
        children: [/*#__PURE__*/_jsx(Input, {
          value: value || '',
          placeholder: placeholder,
          type: inputType,
          id: id,
          name: name,
          variant: "outline",
          inputMode: inputMode,
          autoComplete: autoComplete,
          autoCorrect: autoCorrect,
          autoCapitalize: autoCapitalize,
          pattern: pattern,
          maxLength: maxLength,
          isDisabled: isLoading,
          sx: {
            borderColor: colors.ghost,
            height: 'spacing-7',
            paddingY: 'spacing-sm',
            paddingX: 'spacing-md',
            borderRadius: 'spacing-none',
            backgroundColor: isInvalid ? colors.errorLight : ''
          },
          onChange: onChange,
          onBlur: onBlur,
          "data-id": "form_form-input_FormInput_InputGroup_Input"
        }), type === 'password' && /*#__PURE__*/_jsx(InputRightElement, {
          "data-id": "form_form-input_FormInput_InputRightElement",
          children: /*#__PURE__*/_jsx(IconButton, {
            "aria-label": "".concat(inputType === 'password' ? 'Show' : 'Hide', " password"),
            colorScheme: "quartz",
            variant: "link",
            icon: inputType === 'password' ? /*#__PURE__*/_jsx(EyeOpenMediumIcon, {
              "data-id": "form_form-input_FormInput_EyeOpenMediumIcon"
            }) : /*#__PURE__*/_jsx(EyeClosedMediumIcon, {
              "data-id": "form_form-input_FormInput_EyeClosedMediumIcon"
            }),
            onClick: () => inputType === 'password' ? setInputType('text') : setInputType('password'),
            "data-id": "form_form-input_FormInput_InputRightElement_IconButton"
          })
        })]
      }), errorMessage && /*#__PURE__*/_jsx(FormErrorMessage, {
        sx: {
          marginTop: 'spacing-none',
          color: colors.error,
          fontSize: 'font-sm'
        },
        "data-id": "form_form-input_FormInput_FormErrorMessage",
        children: errorMessage
      })]
    })
  });
};
export default FormInput;